import { configureStore } from '@reduxjs/toolkit';
import adminUserReducer from './adminUser/slice'
import employeesReducer from './employee/slice'
import sidebarMenuReducer from './sidebarMenu/slice'
import payrollReducer from './payroll/slice'
import userFeedbackSlice from "./userFeedback/slice";

export const store = configureStore({
    reducer: {
        adminUser: adminUserReducer,
        employees: employeesReducer,
        sidebarMenu: sidebarMenuReducer,
        payrolls: payrollReducer,
        userFeedback: userFeedbackSlice
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
